import { Avatar, InitialsAvatar } from '@lmc/ui-kit'
import AbsencesPopover from './AbsencesPopover'

type AbsentUserAvatarProps = {
  user: any
}

export const AbsentUserAvatar = ({ user }: AbsentUserAvatarProps) => {
  if (!user) return null

  return (
    <AbsencesPopover users={[user]}>
      <div>
        {user.picture ? (
          <Avatar size={36} url={user.picture} />
        ) : (
          <InitialsAvatar name={`${user.name?.first} ${user.name.last}`} />
        )}
      </div>
    </AbsencesPopover>
  )
}

export default AbsentUserAvatar
